// global-error-handler.ts
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorService } from '../services/error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private isHandlingError = false; // Circuit breaker to prevent infinite loops

  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Always log to console for local developer visibility
    console.error('An unhandled application error occurred:', error);

    // Prevent recursive loops if the error reporting mechanism itself throws
    if (this.isHandlingError) return;

    try {
      this.isHandlingError = true;

      const errorMessage = error?.message ? error.message : error?.toString() || 'Unknown Error';
      const stackTrace = error?.stack || null;

      const path = window.location.pathname;
      const module = path.includes('budget') ? 'budgeting' : 'general';

      // Lazily inject ErrorService to prevent circular dependency injection issues with HttpClient
      const errorService = this.injector.get(ErrorService);

      errorService.logError({
        error_message: errorMessage,
        stack_trace: stackTrace,
        module: module,
        route_path: path,
      });
    } catch (handlerErr) {
      console.error('Error in GlobalErrorHandler itself:', handlerErr);
    } finally {
      this.isHandlingError = false;
    }
  }
}
